import { TableFilterSelectOption } from '@aibees/elephant/components/table-filter-select';
import { useSavedSearchMetadataStore } from '@aibees/elephant/store/saved-search-metadata';
import { ElephantPresetType } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { useSavedSearchMetadata } from './use-saved-search-metadata';

const ALL_KEY = `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}`;

export function useAddSavedSearchTypeMetadata(
  options: TableFilterSelectOption[]
) {
  useSavedSearchMetadata();
  const metadata = useSavedSearchMetadataStore((state) => state.metadata);

  return useMemo(
    () =>
      options.map((o) => {
        if (!metadata) return o;
        const total =
          metadata[ElephantPresetType.COMPANY_SAVED_SEARCH] +
          metadata[ElephantPresetType.PEOPLE_SAVED_SEARCH];
        const count =
          o.key === ALL_KEY ? total : metadata[o.key as keyof typeof metadata];
        return { ...o, metadata: count };
      }),
    [metadata, options]
  );
}
